// Reusable SVG flowchart primitives for decision flows
// Colors: petrol bg #0A3747, lime accent #E0E621, neutral whites/grays

export const FLOW_COLORS = {
  start: { fill: "#0A3747", stroke: "#0A3747", text: "#E0E621" },
  process: { fill: "#FFFFFF", stroke: "#0A3747", text: "#0A3747" },
  decision: { fill: "#FEF3C7", stroke: "#F59E0B", text: "#92400E" },
  success: { fill: "#DCFCE7", stroke: "#10B981", text: "#065F46" },
  danger: { fill: "#FEE2E2", stroke: "#EF4444", text: "#991B1B" },
  ia: { fill: "#F0FFCE", stroke: "#E0E621", text: "#0A3747" },
  end: { fill: "#0A3747", stroke: "#0A3747", text: "#E0E621" },
};

export function FlowBox({ x, y, w = 180, h = 50, type = "process", label, sublabel, testId }) {
  const c = FLOW_COLORS[type];
  return (
    <g data-testid={testId}>
      <rect x={x} y={y} width={w} height={h} rx="6" fill={c.fill} stroke={c.stroke} strokeWidth="1.6" />
      <text
        x={x + w / 2}
        y={y + h / 2 + (sublabel ? -4 : 4)}
        textAnchor="middle"
        fill={c.text}
        fontSize="11"
        fontFamily="IBM Plex Sans, sans-serif"
        fontWeight="600"
      >
        {label}
      </text>
      {sublabel && (
        <text
          x={x + w / 2}
          y={y + h / 2 + 11}
          textAnchor="middle"
          fill={c.text}
          fontSize="9"
          opacity="0.75"
          fontFamily="JetBrains Mono, monospace"
        >
          {sublabel}
        </text>
      )}
    </g>
  );
}

export function FlowDecision({ x, y, w = 140, h = 70, label, testId }) {
  const c = FLOW_COLORS.decision;
  const cx = x + w / 2;
  const cy = y + h / 2;
  return (
    <g data-testid={testId}>
      <polygon
        points={`${cx},${y} ${x + w},${cy} ${cx},${y + h} ${x},${cy}`}
        fill={c.fill}
        stroke={c.stroke}
        strokeWidth="1.6"
      />
      <text
        x={cx}
        y={cy + 4}
        textAnchor="middle"
        fill={c.text}
        fontSize="10"
        fontFamily="IBM Plex Sans, sans-serif"
        fontWeight="600"
      >
        {label}
      </text>
    </g>
  );
}

export function FlowArrow({ from, to, label, color = "#0A3747", curve = false, testId }) {
  // Compute path
  const [x1, y1] = from;
  const [x2, y2] = to;
  let path;
  if (curve) {
    const mx = (x1 + x2) / 2;
    path = `M ${x1} ${y1} Q ${mx} ${y1} ${mx} ${(y1 + y2) / 2} T ${x2} ${y2}`;
  } else {
    path = `M ${x1} ${y1} L ${x2} ${y2}`;
  }
  const lx = (x1 + x2) / 2;
  const ly = (y1 + y2) / 2;
  return (
    <g data-testid={testId}>
      <path d={path} stroke={color} strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
      {label && (
        <g>
          <rect x={lx - 18} y={ly - 8} width="36" height="14" rx="3" fill="white" stroke={color} strokeWidth="0.8" />
          <text
            x={lx}
            y={ly + 2}
            textAnchor="middle"
            fontSize="9"
            fill={color}
            fontFamily="JetBrains Mono, monospace"
            fontWeight="600"
          >
            {label}
          </text>
        </g>
      )}
    </g>
  );
}

export function ArrowMarker() {
  return (
    <defs>
      <marker id="arrowhead" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto">
        <polygon points="0 0, 8 4, 0 8" fill="#0A3747" />
      </marker>
    </defs>
  );
}
